/**
 * Trigger a browser download for a Blob. Uses `file-saver` via a dynamic
 * import so the ~2 KB gzipped library is only fetched the first time the
 * user actually exports something.
 */
export async function downloadBlob(blob: Blob, filename: string): Promise<void> {
  const { saveAs } = await import('file-saver');
  saveAs(blob, filename);
}
